import QRCode, { type QRCodeRenderersOptions, type QRCodeToDataURLOptions } from 'qrcode'
import { loadImage } from '@widgets/shared/utils/loadImage'

interface IQrCodeBase64Options {
  margin: number
  size: number
  logo?: {
    src: string
    width: number
    height: number
  }
}

export default class QrCodeService {
  public async getBase64(text: string, options: IQrCodeBase64Options) {
    const qrCodeOptions = {
      errorCorrectionLevel: 'H',
      type: 'image/png',
      color: { dark: '#000000' },
      margin: options.margin,
      width: options.size,
    } satisfies QRCodeToDataURLOptions & QRCodeRenderersOptions

    if (!options.logo) {
      return QRCode.toDataURL(text, qrCodeOptions)
    }

    const canvas = document.createElement('canvas')
    await QRCode.toCanvas(canvas, text, qrCodeOptions)

    const logo = await loadImage(options.logo.src)
    const ctx = canvas.getContext('2d')

    if (!ctx) {
      throw new Error("Can't get 2d context")
    }

    ctx.drawImage(
      logo,
      options.size / 2 - options.logo.width / 2,
      options.size / 2 - options.logo.height / 2,
      options.logo.width,
      options.logo.height,
    )
    return canvas.toDataURL()
  }
}

export const qrCodeService = new QrCodeService()
